import axiosApiInstance from "../app/axios";
import { PARKIT_API_BASE_URL } from "../app/utils";
import { getJwtToken } from "../app/common";

export const getAllCustomers = async (page, size, sort, sortBy, search) =>
    axiosApiInstance.get(
        `${PARKIT_API_BASE_URL}/parkit/v2/customers?page=${page}&size=${size}&sort=${sort}&sortBy=${sortBy}${search ? '&search=' + encodeURIComponent(search) : ''}`,
        { headers: { Authorization: `Bearer ${getJwtToken()}` } }
    );

export const getCustomerWithInsurance = async (page, size, sort, sortBy, insuranceStatus, search) =>
    axiosApiInstance.get(
        `${PARKIT_API_BASE_URL}/parkit/v2/customers?page=${page}&size=${size}&sort=${sort}&sortBy=${sortBy}&insuranceStatus=${insuranceStatus}${search ? '&search=' + encodeURIComponent(search) : ''}`,
        { headers: { Authorization: `Bearer ${getJwtToken()}` } }
    );

export const getCustomerByUsername = async (username) =>
    axiosApiInstance.get(
        `${PARKIT_API_BASE_URL}/parkit/v2/customers?userName=${username}`,
        { headers: { Authorization: `Bearer ${getJwtToken()}` } }
    );

export const unsubscribeDefenceInsurance = async (customerId) =>
    axiosApiInstance.post(
        `${PARKIT_API_BASE_URL}/parkit/v2/insurances/customers/${encodeURIComponent(customerId)}/unsubscribe`, null,
        { headers: { Authorization: `Bearer ${getJwtToken()}` } }
    );

export const updateCustomer = async (data) =>
    axiosApiInstance.put(
        `${PARKIT_API_BASE_URL}/parkit/v2/customers/update`, data,
        { headers: { Authorization: `Bearer ${getJwtToken()}` } }
    );

// resolveAudience turns user ids or email addresses into {userId, email, firstName}. The campaign
// service stores ids only, so this is what makes a list readable and what validates a paste.
export const resolveAudience = async (userIds = [], emails = []) =>
    axiosApiInstance.post(
        `${PARKIT_API_BASE_URL}/parkit/v2/customers/audience/resolve`, { userIds, emails },
        { headers: { Authorization: `Bearer ${getJwtToken()}` } }
    );

export const getAudience = async (activeSince, limit) => {
    const params = new URLSearchParams();
    if (activeSince) params.set("activeSince", activeSince);
    if (limit) params.set("limit", limit);
    const query = params.toString();
    return axiosApiInstance.get(
        `${PARKIT_API_BASE_URL}/parkit/v2/customers/audience${query ? `?${query}` : ""}`,
        { headers: { Authorization: `Bearer ${getJwtToken()}` } }
    );
};
